import { Injectable } from '@angular/core';
import {catchError, finalize, Observable, of, tap} from "rxjs";
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import * as http from "node:http";
import {CommonResponse} from "../../customs/_models/Response";
import {ClientDto} from "../../customs/_models/client.dtos";
import {cl} from "@fullcalendar/core/internal-common";
@Injectable({
  providedIn: 'root'
})
export class ClientsService {

      constructor(
          private endpoints: Endpoints,
          private http : HttpClient
      ) { }

    public loadClients(): Observable<CommonResponse>{
        return this.http.get<CommonResponse>(this.endpoints.client_base_endpoint);
    }

    public handleSave(client: ClientDto) : Observable<CommonResponse>{
          return this.http.post<CommonResponse>(this.endpoints.client_base_endpoint, client)
    }

    public handleUpDate(client : ClientDto){
          return this.http.put<CommonResponse>(this.endpoints.client_base_endpoint, client)
    }

    public total(){
      return this.http.get<{ success: boolean, message: string, data: number }>(this.endpoints.client_base_endpoint + '/totalClients');
    }
    getChartData(duration: string): Observable<any[]> {
      console.log('Fetching chart data for duration:', duration);
      return this.http.get<any[]>(`${this.endpoints.client_base_endpoint}/data?duration=${duration}`).pipe(
        tap(data => {
          console.log('Données reçues du backend:', data);  // Ajoute ce log ici
        }),
        catchError(err => {
          console.error('Error fetching chart data:', err);
          return of([]); 
        })
      );
    }
    

    getClientSampleData(): Observable<any[]> {
      return this.http.get<any[]>(`${this.endpoints.client_base_endpoint}/sample`).pipe(
        catchError(err => {
          console.error('Error fetching chart data:', err);
          return of([]); // Retourner un tableau vide en cas d'erreur
        })
      );
    }
}
